export const CATALOG_ENDPOINT = `${process.env.REACT_APP_API_HOST}:${process.env.REACT_APP_API_PORT}/v1/catalog`;
